// Chat composer (ChatInput)
// (WEB-8005). Composed by praxisStyles.ts at the section's original
// position — source order is part of the cascade.
export const praxisComposer = `
/* Composer */
.pr-composer-wrap {
  padding: 8px 28px 14px;
  background: var(--pr-surface);
  flex-shrink: 0;
  border-top: 1px solid var(--pr-hairline);
}
.pr-composer { max-width: 760px; margin: 0 auto; }
.pr-composer-box {
  position: relative;
  display: flex; flex-direction: column; gap: 2px;
  padding: 8px 10px 4px;
  background: var(--pr-surface);
  border: 1px solid var(--pr-border);
  border-radius: var(--pr-r-lg);
  transition: border-color 150ms ease, box-shadow 150ms ease;
}
.pr-composer-box.compact {
  flex-direction: row; align-items: center; gap: 8px;
  padding: 4px 6px 4px 10px;
}
.pr-composer-box.focused {
  border-color: var(--pr-accent);
  box-shadow: 0 0 0 3px var(--pr-accent-soft-2);
}
.pr-composer-box.drag {
  border-style: dashed; border-color: var(--pr-accent);
  background: var(--pr-accent-soft);
}
.pr-composer-tool {
  width: 30px; height: 30px; border-radius: var(--pr-r-sm);
  border: none; background: transparent; color: var(--pr-ink-3);
  display: grid; place-items: center; cursor: pointer;
  transition: color 120ms ease, background 120ms ease;
}
.pr-composer-tool:hover { color: var(--pr-ink); background: var(--pr-surface-2); }
.pr-composer-textarea {
  width: 100%; resize: none; outline: none; border: none; background: transparent;
  font-family: var(--pr-font-ui); font-size: 14px; line-height: 1.45;
  color: var(--pr-ink);
  padding: 2px 2px;
  max-height: 240px; min-height: 30px;
}
.pr-composer-box.compact .pr-composer-textarea {
  flex: 1; width: auto; font-size: 14px; line-height: 1.4;
  padding: 4px 2px;
  max-height: 200px; min-height: 20px;
}
.pr-composer-actions {
  display: flex; align-items: center; justify-content: space-between;
  gap: 8px;
}
.pr-composer-actions-left, .pr-composer-actions-right {
  display: flex; align-items: center; gap: 4px;
}
.pr-composer-textarea::placeholder { color: var(--pr-ink-4); }
.pr-composer-counter {
  font-family: var(--pr-font-mono); font-size: 11px;
  color: var(--pr-ink-4);
  padding: 0 6px;
  user-select: none;
  flex-shrink: 0;
}
.pr-send-btn {
  width: 30px; height: 30px; border-radius: var(--pr-r-sm);
  background: #1d3d48; color: #e8f9f8;
  border: none; display: grid; place-items: center; cursor: pointer;
  transition: background 150ms ease;
  flex-shrink: 0;
}
.pr-send-btn:hover { background: #16323b; }
.pr-send-btn:disabled { background: var(--pr-surface-4); color: var(--pr-ink-4); cursor: not-allowed; }
.pr-composer-hints {
  display: flex; justify-content: space-between; align-items: center;
  padding: 8px 2px 0;
  font-size: 11px; color: var(--pr-ink-4);
}
.pr-composer-hints kbd {
  font-family: var(--pr-font-mono); font-size: 10.5px;
  background: var(--pr-surface-2);
  border: 1px solid var(--pr-border);
  border-bottom-width: 1.5px;
  border-radius: 4px;
  padding: 1px 5px;
  color: var(--pr-ink-3);
}
`;
